import { useContext, useMemo } from "react";
import { WdprButton, WdprDivider } from "components/vista";
import { txpMotionClasses, txpMotionDelayMs } from "config-txp";
import { addCurrentRedirectUrl } from "utils";
import { Context } from "Context";
import appConfig from "config.json";
import AnalyticsWrapper from "./AnalyticsWrapper";

const MyPlansSignInPrompt = ({
	mainClass,
	showDivider = true,
	showDescription = true,
	variant = "primary",
	animate = false,
}) => {
	const {
		config: { brand, locale, absoluteLinksFromBrand },
		profileData: { handleLogin },
		headerData: { chrome },
		updatedLocation,
	} = useContext(Context);

	const signIn = chrome?.signIn;
	const signInDescription = chrome?.signInDescription;
	const preventAuthModals =
		appConfig.brands?.[brand]?.oneId?.preventAuthenticationModals;

	const resolvedHref = useMemo(() => {
		if (!preventAuthModals || !signIn?.href) return undefined;
		return addCurrentRedirectUrl(
			signIn.href,
			true,
			false,
			brand,
			locale,
			absoluteLinksFromBrand
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		preventAuthModals,
		signIn?.href,
		updatedLocation,
		brand,
		locale,
		absoluteLinksFromBrand,
	]);

	if (!signIn) return null;

	const signinClass = `${mainClass}__signin-prompt`;
	const animationClasses = animate ? txpMotionClasses.motionFadeIn : "";

	return (
		<div className={signinClass}>
			{showDescription && (
				<span
					className={`${signinClass}__text ${animationClasses}`}
					style={
						animate
							? { animationDelay: `${txpMotionDelayMs.none}ms` }
							: undefined
					}
				>
					{signInDescription}
				</span>
			)}

			<div
				className={`${signinClass}__button ${animationClasses}`}
				style={
					animate ? { animationDelay: `${txpMotionDelayMs.none}ms` } : undefined
				}
			>
				<AnalyticsWrapper analyticsLinkId={signIn.analyticsLinkId}>
					<WdprButton
						slot="primary-button"
						variant={variant}
						size="small"
						display="block"
						href={resolvedHref}
						onClick={(e) => handleLogin(e, null, null, false, false)}
					>
						{signIn.title}
					</WdprButton>
				</AnalyticsWrapper>
			</div>
			{showDivider && (
				<div
					className={`${signinClass}__divider ${animationClasses}`}
					style={
						animate
							? { animationDelay: `${txpMotionDelayMs.tiny}ms` }
							: undefined
					}
				>
					<WdprDivider orientation="horizontal" align="center" />
				</div>
			)}
		</div>
	);
};

export default MyPlansSignInPrompt;
